import React, { useState } from "react"
import NumericCard from "./NumericCard"
import OneResource from "./OneResource"
import { goto, gotoAST } from "./gotoAST"
import SC_CheckBox from "./sc-checkbox"
import { DownIcon, helpIcon, RightArrowIcon } from "src/components/icons-svg"
import Tooltip from "src/components/tooltip"
/**
 * @param props {{
 *  scState:scState
 *  cardElement:import("../../../backend/sc_analyzer/sc_analyzer-interface").CardElement
 *  cardId: string
 * }}
 */
export default function CardElement({ scState, cardElement, cardId }) {
  var [opened, set_opened] = useState(null)
  var [multiSelected, set_multiSelected] = useState(0)
  // console.log({opened,multiSelected})
  console.log("cardElement", cardElement.type, cardElement)
  if (cardElement.type == "expandable-path-resources")
    return (
      <table>
        <tbody>
          {cardElement.resources.map((cardElementResource) => {
            var solidityResource = findResource({
              scState,
              astId: cardElementResource.refernceAstId,
            })
            let isOpened =
              opened == (solidityResource.astId || cardElementResource.name)
            // console.log({ cardElementResource, solidityResource,isOpened})
            return (
              <tr key={solidityResource.astId || cardElementResource.name}>
                <td
                  valign="top"
                  onClick={() => {
                    if (solidityResource.astId) {
                      set_opened(
                        solidityResource.astId == opened
                          ? null
                          : solidityResource.astId,
                      )
                    } else {
                      set_opened(
                        cardElementResource.name == opened
                          ? null
                          : cardElementResource.name,
                      )
                    }
                    set_multiSelected(0)
                  }}
                >
                  <div
                    css={`
                      cursor: pointer;
                    `}
                  >
                    {isOpened ? DownIcon() : RightArrowIcon()}
                  </div>
                </td>
                <td>
                  <OneResource
                    scState={scState}
                    resource={
                      cardElementResource.refernceAstId
                        ? solidityResource
                        : cardElementResource
                    }
                    showProgress={false}
                    cardElementType={cardElement.type}
                  />
                  {isOpened && (
                    <div
                      css={`
                        border-radius: 6px;
                        border: 1px solid #fff;
                        padding: 20px;
                        box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.25);
                      `}
                    >
                      {cardElementResource.occurences.length > 1 &&
                        cardElementResource.occurences.map((multi, index) => {
                          let isSelected = index == multiSelected
                          return (
                            <div
                              css={`
                                font-size: 18px;
                                padding: 5px 10px;
                                display: inline-block;
                                border: 1px solid #959595;
                                cursor: ${isSelected ? "" : "pointer"};
                                background-color: ${isSelected
                                  ? "#D9D9D9"
                                  : ""};
                                color: ${isSelected ? "black" : "#5D5D5D"};
                                margin-bottom: 20px;
                              `}
                              onClick={() => set_multiSelected(index)}
                              key={index}
                            >
                              {index + 1}
                            </div>
                          )
                        })}

                      {[...cardElementResource.occurences[multiSelected].path]
                        .reverse()
                        .map((path, index) => {
                          var pathLength =
                            cardElementResource.occurences[multiSelected].path
                              .length
                          return (
                            <div key={index}>
                              <div
                                //@ts-ignore
                                goto_file="${quoteattr(currentPath.callerFile)}"
                                goto_line="${quoteattr(currentPath.callingOnLine)}"
                                onClick={() =>
                                  goto(
                                    scState,
                                    path.callerFile,
                                    path.callingOnLine,
                                  )
                                }
                                css={`
                                  border-radius: 5px;
                                  border: 1px solid #6b6969;
                                  cursor: pointer;
                                  padding: 10px;
                                  ${index == pathLength - 1
                                    ? "border:4px solid #000AFF;"
                                    : ""}
                                  :hover {
                                    background: #efefef;
                                  }
                                `}
                              >
                                <div
                                  css={`
                                    font-size: 28px;
                                  `}
                                >
                                  {path.callerName}
                                </div>
                                <div
                                  css={`
                                    font-size: 17px;
                                    color: #808080;
                                    font-style: italic;
                                    margin-top: 5px;
                                  `}
                                >
                                  Defined in {path.callerContract} contract
                                </div>
                                <div
                                  css={`
                                    font-size: 20px;
                                    margin-top: 9px;
                                  `}
                                >
                                  The {path.callerType} <i>{path.callerName}</i>{" "}
                                  is using the {path.callingOnType}{" "}
                                  <i>{path.callingOnName}</i> of{" "}
                                  <i>{path.callingOnContract}</i> contract
                                </div>
                              </div>
                              {index < pathLength - 1 && (
                                <center css="margin:5px 0px;">
                                  <img src="down-arrow.png" />
                                </center>
                              )}
                            </div>
                          )
                        })}
                    </div>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  if (cardElement.type == "task") {
    let isChecked = scState.completedTasks[cardId + "_" + cardElement.id]
    function set_isChecked(bool) {
      //@ts-ignore
      scState.completedTasks[cardId + "_" + cardElement.id] = bool
      scState.set_completedTasks({
        ...scState.completedTasks,
      })
      scState.saveTasks()
    }
    return (
      <table>
        <tbody>
          <tr>
            <td
              valign="middle"
              onClick={() => set_isChecked(!isChecked)}
              css={`
                cursor: pointer;
                display: inline-flex;
              `}
            >
              <SC_CheckBox checked={isChecked} />
            </td>
            <td width="100%">
              <div
                css="display: flex;
                  align-items: center;
                  justify-content: flex-start;"
              >
                <div
                  css={`
                    cursor: pointer;
                    display: inline-flex;
                  `}
                  onClick={() => set_isChecked(!isChecked)}
                >
                  {cardElement.title}
                </div>
                {!cardElement.help && (
                  <div>
                    <Tooltip tip={"Help text coming soon"}>
                      {helpIcon(15)}
                    </Tooltip>
                  </div>
                )}
              </div>
            </td>
            <td>
              <div
                css="
                  cursor:pointer;
                  display:none;
                  color:blue;
                  text-decoration:underline;
                  font-size: 0.875rem;
                  "
                onClick={() => {
                  scState.testSimulation(cardElement.id, cardElement.title)
                }}
              >
                Test
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
  if (cardElement.type == "resources-flattened") {
    console.log("astIDs", cardElement.astIDs)
    return (
      <div>
        {cardElement.astIDs.map((res) => {
          console.log("resource", { res })
          var resource = findResource({ scState, astId: res })
          console.log("resource", { resource })
          return (
            <div
              css={`
                display: inline-block;
                margin-right: 5px;
                margin-bottom: 5px;
              `}
              key={resource.astId}
            >
              <OneResource
                scState={scState}
                resource={resource}
                showProgress={false}
              />
            </div>
          )
        })}
      </div>
    )
  }
  if (cardElement.type == "expandable-resources")
    return (
      <table>
        <tbody>
          {cardElement.resources.map((cardElementResource) => {
            var solidityResource = findResource({
              scState,
              astId: cardElementResource.refernceAstId,
            })
            // console.log({ cardElementResource, solidityResource})
            return (
              <tr key={solidityResource.astId}>
                <td
                  valign="top"
                  onClick={() =>
                    set_opened({
                      ...opened,
                      [solidityResource.astId]: !opened[solidityResource.astId],
                    })
                  }
                >
                  <div
                    css={`
                      cursor: pointer;
                    `}
                  >
                    {opened[solidityResource.astId] ? "-" : "+"}
                  </div>
                </td>
                <td>
                  <OneResource
                    scState={scState}
                    resource={solidityResource}
                    showProgress={false}
                  />
                  {opened[solidityResource.astId] && (
                    <div
                      css={`
                        border: 1px solid #cbcbcb;
                      `}
                    >
                      {/* <div css={`background-color:#C9C9C9;padding:5px 10px;`} dangerouslySetInnerHTML={{ __html: cardElementResource.multi[multiSelected].expandedTitle }} /> */}
                      <div
                        css={`
                          padding: 10px;
                        `}
                        dangerouslySetInnerHTML={{
                          __html:
                            cardElementResource.multi[multiSelected]
                              .expandedHTML,
                        }}
                      />
                      {cardElementResource.multi.map((multi, index) => (
                        <div
                          onClick={() => set_multiSelected(index)}
                          key={index}
                        >
                          {index + 1} {(index == multiSelected).toString()}
                        </div>
                      ))}
                    </div>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  if (cardElement.type == "resources")
    return (
      <div>
        {cardElement.resources.map((res) => {
          var resource = findResource({ scState, astId: res.refernceAstId })
          console.log("resource", resource)
          return (
            <div
              css={`
                display: inline-block;
                margin-right: 5px;
                margin-bottom: 5px;
              `}
              key={resource.astId}
            >
              <OneResource
                scState={scState}
                resource={resource}
                showProgress={false}
              />
            </div>
          )
        })}
      </div>
    )
  if (cardElement.type == "table")
    return (
      <table
        cellPadding={0}
        cellSpacing={0}
        width="100%"
        css={`
          margin-bottom: 20px;
          background-color: #fbfbfb;
          border: 1px solid #949494;
        `}
      >
        <tbody>
          <tr>
            <td colSpan={2}>
              <div
                css={`
                  background-color: #dedcdc;
                  padding: 10px 30px;
                  font-weight: 100;
                `}
                dangerouslySetInnerHTML={{
                  __html: cardElement.title,
                }}
              ></div>
            </td>
          </tr>
          <tr>
            {cardElement.headers.map((header, idx) => (
              <td key={idx}>
                <div
                  css={`
                    padding: 10px 30px;
                  `}
                >
                  {header}
                </div>
              </td>
            ))}
          </tr>
          {cardElement.body.map((x, idx) => (
            <tr key={idx}>
              {x.map((x, idx) => (
                <td
                  key={idx}
                  css={`
                    border-top: 1px solid #dbdbdb;
                  `}
                >
                  <div
                    css={`
                      padding: 10px 30px;
                      font-weight: 100;
                    `}
                  >
                    {x}
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    )
}

/**
 * @param props {{
 *  scState:scState
 *  astId:number
 * }}
 */
export function findResource({ scState, astId }) {
  // console.log('Search for:' + astId)
  for (let tab of scState.json.tabsArray) {
    // console.log("Search in tab: " + tab.name)
    let resource = tab.elements.find((x) => x.astId == astId)
    if (resource) return resource
  }
  // console.log('Not found')
}
